export const calculateVariantsTotalPrice = (price: string) => {
    if (!price || price === 'Blank') return 0

    const total = price
        .split(',')
        .map((num) => Number(num.trim()))
        .reduce((accumulator, current) => accumulator + current, 0)

    return total ?? 0
}
